export default "__VITE_ASSET__Cn12s2H$__"